import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "minutesToHoursDecimal",
})
export class MinutesToHoursDecimalPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}
  transform(value: number, formatString?: string): string {
    return this.decimalPipe.transform(Math.round(value / 60 * 100) / 100, formatString);
  }
}
